export type Referrer = {
  utmSource: string
  utmMedium: string
  utmCampaign: string
  utmContent: string
}

const referrerHostname = () => {
  if (!document) {
    return ""
  }
  if (!document.referrer) {
    return ""
  }
  const referrer = new URL(document.referrer)
  return referrer.host
}

export const referrerEvent = (): Referrer | undefined => {
  const host = referrerHostname()
  if (!host) {
    return undefined
  }
  const searchHosts = ["google", "yahoo", "bing"]
  for (const searchHost of searchHosts) {
    if (host.indexOf(searchHost) !== -1) {
      return {
        utmSource: searchHost,
        utmMedium: "organic_search",
        utmCampaign: "",
        utmContent: "",
      }
    }
  }
  const socialHosts = [
    "twitter",
    "facebook",
    "instagram",
    "line",
    "tiktok",
    "youtube",
    "pinterest",
  ]
  for (const socialHost of socialHosts) {
    if (host.indexOf(socialHost) !== -1) {
      return {
        utmSource: socialHost,
        utmMedium: "organic_social",
        utmCampaign: "",
        utmContent: "",
      }
    }
  }
  return { utmSource: host, utmMedium: "organic_other", utmCampaign: "", utmContent: "" }
}
